import React, { useEffect, useState, useRef } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Paper,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Draggable from "react-draggable";

/**
 * Props:
 * - open: boolean (dialog open/close state)
 * - onClose: function (close handler)
 * - base64: string (base64 content)
 * - mimeType: string (like 'application/pdf', 'image/png', etc.)
 * - title: string (optional dialog title)
 */

const Base64ViewerDialog = ({ open, onClose, base64, mimeType, title }) => {
  const [blobUrl, setBlobUrl] = useState("");

  useEffect(() => {
    if (open && base64) {
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length)
        .fill(0)
        .map((_, i) => byteCharacters.charCodeAt(i));
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: mimeType });
      const url = URL.createObjectURL(blob);
      setBlobUrl(url);

      return () => {
        URL.revokeObjectURL(url); // cleanup on close
        setBlobUrl("");
      };
    }
  }, [open, base64, mimeType]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      disableScrollLock
      PaperComponent={DraggableDialogPaper}
    >
      <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
        {title}
        <IconButton
          onClick={onClose}
          style={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {blobUrl &&
          (mimeType.startsWith("image/") ? (
            <iframe
              title="Image Preview"
              className="image-preview-iframe"
              srcDoc={`
                                <html>
                                    <head>
                                        <style>
                                            body {
                                                margin: 0;
                                                background-color: #f8f8f8;
                                                display: flex;
                                                align-items: center;
                                                justify-content: center;
                                                height: 100vh;
                                            }
                                            img {
                                                max-width: 100%;
                                                max-height: 100%;
                                            }
                                        </style>
                                    </head>
                                    <body>
                                        <img src="${blobUrl}" alt="Preview Image" />
                                    </body>
                                </html>
                            `}
            />
          ) : (
            <iframe
              src={blobUrl}
              title="File Preview"
              className="image-preview-iframe"
            />
          ))}
      </DialogContent>
    </Dialog>
  );
};

const DraggableDialogPaper = (props) => {
  const nodeRef = useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      bounds="parent"
      handle="#draggableDialogPaper"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper ref={nodeRef} {...props} />
    </Draggable>
  );
};

export default Base64ViewerDialog;
